export default "__VITE_ASSET__4aebeae2__"